const BASE_URL = process.env['GATSBY_BASE_URL'];

export async function fetchHandler(path, options = {}) {
  try {
    const session = localStorage.getItem('session')
    // Проверяем валидность токена (должен содержать только ASCII символы)
    if (session && !/^[\x00-\x7F]*$/.test(session)) {
      localStorage.removeItem('session')
      return {
        status: 401,
        statusText: 'Unauthorized',
        data: { message: 'Invalid token format' },
        isUnauthorized: true
      }
    }

    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }

    if (session) {
      headers['Authorization'] = `Bearer ${session}`
    }

    const response = await fetch(`${BASE_URL}${path}`, {
      ...options,
      headers
    })

    const contentType = response.headers.get('Content-Type') || ''

    if (!response.ok) {
      const errorData = contentType.includes('application/json')
        ? await response.json()
        : await response.text()

      // Если получаем 401 (Unauthorized), очищаем невалидную сессию
      if (response.status === 401) {
        localStorage.removeItem('session')
        return {
          status: response.status,
          statusText: response.statusText,
          data: errorData,
          isUnauthorized: true // Специальный флаг для вызова модалки авторизации
        }
      }

      return {
        status: response.status,
        statusText: response.statusText,
        data: errorData
      }
    }

    // Успешный ответ
    if (contentType.includes('application/json')) {
      const jsonResponse = await response.json()
      return jsonResponse
    } else {
      const textResponse = await response.text()
      return textResponse
    }
  } catch (error) {
    return error?.message || 'Ошибка запроса'
  }
};
